// knowledgeDetails.pipeline.documents.* — owned by the documents page.
export default {
  title: 'Documents',
  intro:
    'Every document walks the same pipeline. The dots show how far each one got; open a row for each stage’s log and its one recovery action.',
  row: {
    openJourney: '{{state}}. Open the pipeline for {{name}}',
    progress: '{{pct}}%',
    progressHint:
      'This document’s own progress, weighted across its stages. Not the share of documents done.',
    inFlight:
      'A connector import is processing this document. It can be re-run once the import finishes.',
    queuing: 'Sending the request…',
    virtual: 'Not parsed',
    virtualHint:
      'A virtual document holds no file, so there is nothing to parse.',
    errorAt: 'Failed at {{stage}}',
    tokens: '{{n}} tokens',
    enabled: 'enabled',
    disabled: 'disabled',
    upload: 'Upload',
    started: 'started {{time}}',
  },
  header: {
    documents_one: '{{n}} document',
    documents_other: '{{n}} documents',
    chunks: '{{n}} chunks counted',
  },
  legend: {
    dots: 'Stage dots',
  },
  columns: {
    source: 'Source',
    method: 'Method',
    size: 'Size',
    chunks: 'Chunks',
    stages: 'Stages',
    state: 'State',
    duration: 'Duration',
    next: 'Next action',
    updated: 'Updated',
  },
  filters: {
    showing: 'Showing:',
    allStates: 'all states',
    in: 'in',
    wholeKb: 'the whole knowledge base',
    count: '{{n}} of {{total}} documents',
    clear: 'Clear filters',
    all: 'All',
  },
  process: {
    parseHint:
      'Runs the pipeline on the selected documents; existing chunks are kept.',
    reparseCost: '(deletes chunks)',
    reparseHint:
      'Deletes all existing chunks, then parses again from the source file.',
    cancelHint:
      'Stops a document that is Parsing; its state becomes Cancelled.',
    deleteHint:
      'Removes the document and its chunks. A document being parsed cannot be deleted.',
  },
  actions: {
    parse: 'Parse',
    parseHint: 'Run the pipeline on this document.',
    cancel: 'Cancel',
    cancelHint: 'Stop parsing. The document becomes Cancelled.',
    reparse: 'Re-parse',
    reparseHint_one: 'Deletes this document’s chunk, then parses it again.',
    reparseHint_other:
      'Deletes this document’s {{count}} chunks, then parses it again.',
    deletes_one: 'deletes {{count}} chunk',
    deletes_other: 'deletes {{count}} chunks',
  },
  journey: {
    started: 'Started {{when}}',
    notStarted: 'Not started yet',
    elapsed: '{{duration}} processing',
    chunks_one: '{{count}} chunk',
    chunks_other: '{{count}} chunks',
    tokens: '{{n}} tokens',
    progress: '{{pct}}% of this document',
    openChunks: 'Open chunks ({{count}})',
    uploaded: 'uploaded {{when}}',
    stagesTitle: 'Stages',
    stagesHint:
      'Click a stage to show its log. Durations are measured from the log timestamps.',
    stagesHintRecorded:
      'Click a stage to see what happened in it, including what it waited for. Times are recorded by each step, to the millisecond.',
    journeyTitle: 'What happened, in order',
    pinnedError: 'Stopped at {{stage}}',
    status: {
      done: 'Done',
      active: 'In progress',
      failed: 'Failed',
      cancelled: 'Cancelled',
      pending: 'Not started',
      na: 'Not used',
    },
    noLines: 'No log lines for this stage.',
    resume: 'Resume from last step',
    resumeTitle: 'Resume from where it stopped?',
    resumeHint:
      'Only incomplete tasks will be re-queued. Completed steps will not be repeated.',
    resumeOk: 'Resume',
    restart: 'Restart {{step}}',
    restartTitle: 'Restart {{step}}?',
    restartHint:
      'This step will re-run from scratch. Other completed steps are not affected.',
    reparseInstead:
      'This stage runs inside the document’s parse task, so the way back is Re-parse.',
    timeline: {
      title: 'Timeline',
      range: '{{from}} → {{to}} · {{duration}}',
      longest: 'Longest step: {{stage}}, {{duration}}',
      hint: 'Read from the log timestamps. A stage runs from where the previous one ended to its own last line.',
      earlier: 'Earlier attempt',
      unlogged: 'its log lines were replaced when it restarted',
      restartedBy: 'Restarted: {{line}}',
      latest: 'Latest attempt · {{range}}',
    },
    steps: {
      contextualise: 'Contextualise',
      graphrag: 'GraphRAG',
      entity_resolution: 'Entity resolution',
    },
  },
  summary: {
    legend: 'Document states',
    tileHint:
      'Show every {{state}} document in the knowledge base as one flat list. Folders are hidden while it is on.',
    clearFilter: 'Back to folders',
  },
  folder: {
    done: '{{pct}}% done',
    breakdown:
      '{{done}} Done · {{parsing}} Parsing · {{failed}} Failed · {{cancelled}} Cancelled · {{pending}} Pending',
    open: 'Open folder',
    pctHint:
      'Documents Done ÷ documents in this folder. A document row’s percentage is that document’s own progress.',
  },
};
